<template>
  <v-dialog v-model="dialog" width="400px">
    <v-card>
      <v-card-title class="headline m-0">
        <v-flex xs9>
          <v-icon>warning</v-icon> Advertencia
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <h3>¿Desea anular el cronograma?</h3>
        <br />
        <h4>Nota: Esta acción es irreversible</h4>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="close()">
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          @click.prevent="anularCronogramaDetalle()"
          :loading="loading"
        >
          Anular
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      form: {},
      loading: false,
      id: null
    };
  },
  mounted() {
    this.$bus.$on("openDialogAnularCronograma", item => {
      this.form = item;

      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.dialog = false;
      this.form = {};
      this.loading = false;
      this.$bus.$emit('closeDialogAnularCronograma')
    },
    async anularCronogramaDetalle() {
      this.loading = true;

      let user = this.$storage.get("user");
      let respuesta;
      let resps = [];
      let correcto = true;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select vacaciones.fn_solicita_anula_vacacion_programada(${this.form.id},9,${user.id})"){
                  respuesta
                }
              }
            `
        });
      } catch (error) {
        console.log(error);
      }
      try {
        respuesta =
          respuesta.runQuery.respuesta[0].fn_solicita_anula_vacacion_programada;
        resps = respuesta.split("|");
        console.log(resps);
        correcto = resps[0] == 1;
      } catch (error) {
        console.log(error);
      }

      if (correcto) {
        this.$message.success();
        this.loading = false;
        this.close();
      } else {
        this.$message.error(resps[1]);
      }
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/AnularCronograma.vue